import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3af720dd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document-card-option-place" }
const _hoisted_2 = ["title"]
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = ["title"]
const _hoisted_5 = {
  key: 1,
  class: "document-card-business-function transparent-bg"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"margin":"10px 0"},
  class: "line"
}, " ", -1))
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "document-card-edited p3 grey-1 d-flex justify-content-between align-items-center" }
const _hoisted_9 = { style: {"padding":"10px 0"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-summary" }, "PROGRESS SUMMARY", -1))
const _hoisted_11 = { style: {"margin-bottom":"0"} }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-label" }, "Answered:", -1))
const _hoisted_13 = { class: "progress-value" }
const _hoisted_14 = { style: {"margin-bottom":"0"} }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "progress-label" }, "Total question:", -1))
const _hoisted_16 = { class: "progress-value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, " ", -1))
const _hoisted_18 = { class: "last-edited-wrapper" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "last-edited-label" }, "Last edited:", -1))
const _hoisted_20 = { class: "last-edited-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_option_drop_down_row = _resolveComponent("option-drop-down-row")!
  const _component_option_drop_down = _resolveComponent("option-drop-down")!
  const _component_Progress_bar = _resolveComponent("Progress-bar")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass({
      'document-card': true,
      'document-card-small': _ctx.isCardTypeSmall,
    })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_option_drop_down, null, {
        default: _withCtx(() => [
          _createVNode(_component_option_drop_down_row, {
            class: "white-hover",
            text: "Archive",
            onHandleClick: _ctx.archiveDocument
          }, null, 8, ["onHandleClick"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", {
        class: "document-card-name heading-5 black mb-8",
        title: _ctx.name
      }, _toDisplayString(_ctx.name), 9, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.getBusinessFunction(_ctx.filterValues))
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              title: _ctx.getBusinessFunction(_ctx.filterValues),
              class: "document-card-business-function"
            }, _toDisplayString(_ctx.getBusinessFunction(_ctx.filterValues)), 9, _hoisted_4))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " "))
      ])
    ]),
    _hoisted_6,
    (_ctx.isUpdatePending)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "processing-icon",
          src: require('@/assets/img/process.png'),
          alt: "processing",
          width: "24",
          height: "24"
        }, null, 8, _hoisted_7))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("p", _hoisted_11, [
          _hoisted_12,
          _createTextVNode(),
          _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.document.answers_progress), 1)
        ]),
        _createElementVNode("p", _hoisted_14, [
          _hoisted_15,
          _createTextVNode(),
          _createElementVNode("b", _hoisted_16, _toDisplayString(_ctx.document.answers_progress), 1)
        ])
      ]),
      _createVNode(_component_Progress_bar, { progress: _ctx.progress }, null, 8, ["progress"])
    ]),
    _hoisted_17,
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createTextVNode(),
      _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.format(new Date(_ctx.lastEdited), "MMM d, yyyy")), 1)
    ])
  ], 2))
}